var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from 'react';
import { renderDynamicComponent } from '../render';
var ContentAnchor = function (_a) {
    var control = _a.control, dataState = _a.dataState;
    var _b = __read(useState(control.children), 2), content = _b[0], setContent = _b[1];
    // useEffect(() => {
    // 	return ContentAnchor$
    // 		.subscribe(event => {
    // 			if (event.name == control.name) {
    // 				setContent(event.layout);
    // 			}
    // 		}).unsubscribe;
    // }, [])
    return React.createElement(React.Fragment, null, content
        .map(function (child, index) { return renderDynamicComponent(1, child, dataState); }));
};
export default ContentAnchor;
//# sourceMappingURL=ContentAnchor.js.map